module.exports = __webpack_public_path__ + "img/cq-tab-icon5.16d1d33a.png";